import { CellType, TableConfig } from '@common/types';

export const tableConfig: TableConfig = {
  columns: [
    {
      title: '№',
      dataIndex: 'ID',
      key: 'ID',

      active: true,
      type: CellType.Input,

      ellipsis: true,
      sorting: 3,

      invisible: true
    },
    {
      title: 'ТС',
      dataIndex: 'Name',
      key: 'Name',
      active: true,
      type: CellType.Input,
      ellipsis: true,
      filtering: 'array',
      width: 100,

      sorting: 3
    },
    {
      title: 'Рег.Номер',
      dataIndex: 'Number',
      key: 'Number',
      active: true,
      type: CellType.RegNumber,
      ellipsis: true,
      filtering: 'array',
      width: 70,

      sorting: 3
    },
    {
      title: 'Водитель',
      dataIndex: 'DriverName',
      key: 'DriverName',
      active: false,
      type: CellType.Input,
      ellipsis: true,
      filtering: 'array',
      width: 100,

      sorting: 3,

      invisible: true
    },
    {
      title: 'Телефон',
      dataIndex: 'Phone',
      key: 'Phone',
      active: false,
      type: CellType.Phone,
      filtering: 'string',
      ellipsis: true,
      width: 80,

      sorting: 3,

      invisible: true
    },
    {
      title: 'Время',
      dataIndex: 'EventTime',
      key: 'EventTime',
      active: true,
      type: CellType.Text,
      ellipsis: true,
      width: 100,

      sorting: 3
    },
    {
      title: 'Скорость, км/ч',
      dataIndex: 'Speed',
      key: 'Speed',
      active: true,
      type: CellType.Int,
      ellipsis: true,
      filtering: 'string',

      sorting: 3
    },
    {
      title: 'Изменения показаний датчика топлива, л',
      dataIndex: 'FuelDrain',
      key: 'FuelDrain',
      active: true,
      type: CellType.Input,
      filtering: 'string',
      ellipsis: true,
      width: 100,

      sorting: 3
    },
    {
      titleText: 'Кнопка - Посмотреть на карте',
      titleTooltip: 'Посмотреть на карте',
      titleIcon: 'location',
      dataIndex: 'FocusOnMap',
      key: 'FocusOnMap',
      type: CellType.IconAction,
      ellipsis: true,

      width: 30
    },
    {
      title: 'Просмотрено',
      titleText: 'Просмотрено',
      titleTooltip: 'Просмотрено',
      dataIndex: 'Viewed',
      key: 'Viewed',
      active: true,
      type: CellType.IconAction, //to new => checkboxIcon
      ellipsis: true,
      width: 40,

      sorting: 3
    }
    //убрали до реализации функционала
    // {
    //   title: 'Избранное',
    //   dataIndex: 'Favourite',
    //   key: 'Favourite',
    //   active: true,
    //   type: CellType.Select, //to new => checkboxIcon
    //   ellipsis: true,
    //   options: [
    //     { label: '', value: 0 },
    //     { label: 'Избранное', value: 1 }
    //   ],
    //   width: 70,
    //   editable: true,
    //
    //   sorting: 3,
    //
    //   filtering: 'array'
    // }
  ],
  adding: false,
  deleting: false,
  reloading: false,
  selecting: false,
  copying: false
};
